import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/tailwind.css";
import "./styles/surfaces.css";
import "./styles/app.css";
// SVAR Gantt CSS is no longer loaded here: it lives in `styles/gantt-vendor.css`,
// imported by each Gantt wrapper so it ships in the lazy Gantt chunks instead of
// the entry bundle (task 106 §1.2). See docs/frontend/svar-decisions.md §6.
import "./i18n";
import "./registerSW";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) {
  throw new Error("missing #root in index.html");
}
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
